export const shyComponentChangeEventName = "shycomponentchange";
export const hoverableTooltipMouseEnteredEventName =
  "hoverableTooltipMouseEntered";
export const hoverableTooltipMouseLeaveEventName = "hoverableTooltipMouseLeave";
